export const DURATION = {
  DAILY: 1,
  WEEKLY: 2,
  MONTHLY: 3,
};
